import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const includeFields = [ "ESTIMATED_ARRIVAL_DATE", "SCHEDULED_DELIVERY_TIME",
 "SHIP_METHOD", "PROVIDER_ID", "SHIP_DATE", "SHIP_OPTION", "PROMISED_DELIVERY_DATE"];

 const metricProcessName = "SCC_PACKAGE_SEARCH";

export async function batchGetPackageSummaryForTrackingId(identifiers) {
    const trackingIdRequest = {
        "idType": "TRACKING_ID",
        "identifiers": identifiers
    };
    var finalResult = [];
    finalResult = finalResult.concat(await apiCall(trackingIdRequest));
    return finalResult;
}

export async function batchGetPackageSummaryForPackageId(identifiers) {
    const packageIdRequest = {
        "idType": "PACKAGE_ID",
        "identifiers": identifiers
    };
    var finalResult = [];
    finalResult = finalResult.concat(await apiCall(packageIdRequest));
    return finalResult;
}

export async function batchGetPackageSummary(identifiers, nodeId, setLoaderProgress, chunk) {
    // const packageIdRequest = {
    //     "idType": "PACKAGE_ID",
    //     "identifiers": identifiers,
    //     "includeFields": includeFields
    // };
    
    var finalResult = [];
    var startIter,endIter,currentIdentifers;
    var addressFieldsEnabled = false;
    var hazmatVisibilityEnabled = false;
    for (startIter=0,endIter=identifiers.length; startIter<endIter; startIter+=chunk) {
        currentIdentifers = identifiers.slice(startIter,startIter+chunk);
        const trackingIdRequest = {
            "idType": "TRACKING_ID",
            "identifiers": currentIdentifers,
            "nodeId": nodeId,
            "includeFields": includeFields
        };
        var output = await batchGetPackageSummaryCall(trackingIdRequest);
        finalResult = finalResult.concat(output.packageSummaryList);
        addressFieldsEnabled = output.addressFieldsEnabled;
        hazmatVisibilityEnabled = output.hazmatVisibilityEnabled;
        setLoaderProgress(Math.trunc((startIter + chunk) * 100 /identifiers.length));
    }
    // finalResult = finalResult.concat(await apiCall(packageIdRequest));
    return {
        packageSummaryList: finalResult,
        addressFieldsEnabled: addressFieldsEnabled,
        hazmatVisibilityEnabled: hazmatVisibilityEnabled
    };
}

async function batchGetPackageSummaryCall(requestBody) {
    const request = {
        resourcePath: "/os/batchGetPackageSummary",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }
    const startTime = Date.now();

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "batchGetPackageSummary", true);
            return response.data;
        } else {
            return {
                packageSummaryList: [],
                addressFieldsEnabled: false,
                hazmatVisibilityEnabled: false
            };
        }

    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, "batchGetPackageSummary", false);
        return {
            packageSummaryList: [],
            addressFieldsEnabled: false,
            hazmatVisibilityEnabled: false
        };
    }
}

async function apiCall(requestBody) {
    const request = {
        resourcePath: "/os/batchGetPackageSummary",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }
    const startTime = Date.now();

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "batchGetPackageSummary", true);
            return response.data.packageSummaryList;
        } else {
            return [];
        }
        
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, "batchGetPackageSummary", false);
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/commons/api/BatchGetPackageSummaryResults.js